import w from "./highrise1004.mjs";
import z from "./highrise987.mjs";
function L(f) {
  const {
    heightTiny: H,
    heightSmall: S,
    heightMedium: T,
    heightLarge: D,
    borderRadius: u,
    fontSizeTiny: F,
    fontSizeSmall: G,
    fontSizeMedium: $,
    fontSizeLarge: W,
    opacityDisabled: E,
    textColor2: e,
    textColor3: I,
    primaryColorHover: r,
    primaryColorPressed: s,
    borderColor: v,
    primaryColor: t,
    baseColor: o,
    infoColor: l,
    infoColorHover: i,
    infoColorPressed: b,
    successColor: d,
    successColorHover: x,
    successColorPressed: P,
    warningColor: c,
    warningColorHover: a,
    warningColorPressed: p,
    errorColor: n,
    errorColorHover: C,
    errorColorPressed: y,
    fontWeight: O,
    buttonColor2: h,
    buttonColor2Hover: m,
    buttonColor2Pressed: g,
    fontWeightStrong: R
  } = f;
  return Object.assign(Object.assign({}, w), {
    heightTiny: H,
    heightSmall: S,
    heightMedium: T,
    heightLarge: D,
    borderRadiusTiny: u,
    borderRadiusSmall: u,
    borderRadiusMedium: u,
    borderRadiusLarge: u,
    fontSizeTiny: F,
    fontSizeSmall: G,
    fontSizeMedium: $,
    fontSizeLarge: W,
    opacityDisabled: E,
    // secondary
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: h,
    colorSecondaryHover: m,
    colorSecondaryPressed: g,
    // tertiary
    colorTertiary: h,
    colorTertiaryHover: m,
    colorTertiaryPressed: g,
    // quaternary
    colorQuaternary: "#0000",
    colorQuaternaryHover: m,
    colorQuaternaryPressed: g,
    // default type
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: e,
    textColorTertiary: I,
    textColorHover: r,
    textColorPressed: s,
    textColorFocus: r,
    textColorDisabled: e,
    textColorText: e,
    textColorTextHover: r,
    textColorTextPressed: s,
    textColorTextFocus: r,
    textColorTextDisabled: e,
    textColorGhost: e,
    textColorGhostHover: r,
    textColorGhostPressed: s,
    textColorGhostFocus: r,
    textColorGhostDisabled: e,
    border: `1px solid ${v}`,
    borderHover: `1px solid ${r}`,
    borderPressed: `1px solid ${s}`,
    borderFocus: `1px solid ${r}`,
    borderDisabled: `1px solid ${v}`,
    rippleColor: t,
    // primary
    colorPrimary: t,
    colorHoverPrimary: r,
    colorPressedPrimary: s,
    colorFocusPrimary: r,
    colorDisabledPrimary: t,
    textColorPrimary: o,
    textColorHoverPrimary: o,
    textColorPressedPrimary: o,
    textColorFocusPrimary: o,
    textColorDisabledPrimary: o,
    textColorTextPrimary: t,
    textColorTextHoverPrimary: r,
    textColorTextPressedPrimary: s,
    textColorTextFocusPrimary: r,
    textColorTextDisabledPrimary: e,
    textColorGhostPrimary: t,
    textColorGhostHoverPrimary: r,
    textColorGhostPressedPrimary: s,
    textColorGhostFocusPrimary: r,
    textColorGhostDisabledPrimary: t,
    borderPrimary: `1px solid ${t}`,
    borderHoverPrimary: `1px solid ${r}`,
    borderPressedPrimary: `1px solid ${s}`,
    borderFocusPrimary: `1px solid ${r}`,
    borderDisabledPrimary: `1px solid ${t}`,
    rippleColorPrimary: t,
    // info
    colorInfo: l,
    colorHoverInfo: i,
    colorPressedInfo: b,
    colorFocusInfo: i,
    colorDisabledInfo: l,
    textColorInfo: o,
    textColorHoverInfo: o,
    textColorPressedInfo: o,
    textColorFocusInfo: o,
    textColorDisabledInfo: o,
    textColorTextInfo: l,
    textColorTextHoverInfo: i,
    textColorTextPressedInfo: b,
    textColorTextFocusInfo: i,
    textColorTextDisabledInfo: e,
    textColorGhostInfo: l,
    textColorGhostHoverInfo: i,
    textColorGhostPressedInfo: b,
    textColorGhostFocusInfo: i,
    textColorGhostDisabledInfo: l,
    borderInfo: `1px solid ${l}`,
    borderHoverInfo: `1px solid ${i}`,
    borderPressedInfo: `1px solid ${b}`,
    borderFocusInfo: `1px solid ${i}`,
    borderDisabledInfo: `1px solid ${l}`,
    rippleColorInfo: l,
    // success
    colorSuccess: d,
    colorHoverSuccess: x,
    colorPressedSuccess: P,
    colorFocusSuccess: x,
    colorDisabledSuccess: d,
    textColorSuccess: o,
    textColorHoverSuccess: o,
    textColorPressedSuccess: o,
    textColorFocusSuccess: o,
    textColorDisabledSuccess: o,
    textColorTextSuccess: d,
    textColorTextHoverSuccess: x,
    textColorTextPressedSuccess: P,
    textColorTextFocusSuccess: x,
    textColorTextDisabledSuccess: e,
    textColorGhostSuccess: d,
    textColorGhostHoverSuccess: x,
    textColorGhostPressedSuccess: P,
    textColorGhostFocusSuccess: x,
    textColorGhostDisabledSuccess: d,
    borderSuccess: `1px solid ${d}`,
    borderHoverSuccess: `1px solid ${x}`,
    borderPressedSuccess: `1px solid ${P}`,
    borderFocusSuccess: `1px solid ${x}`,
    borderDisabledSuccess: `1px solid ${d}`,
    rippleColorSuccess: d,
    // warning
    colorWarning: c,
    colorHoverWarning: a,
    colorPressedWarning: p,
    colorFocusWarning: a,
    colorDisabledWarning: c,
    textColorWarning: o,
    textColorHoverWarning: o,
    textColorPressedWarning: o,
    textColorFocusWarning: o,
    textColorDisabledWarning: o,
    textColorTextWarning: c,
    textColorTextHoverWarning: a,
    textColorTextPressedWarning: p,
    textColorTextFocusWarning: a,
    textColorTextDisabledWarning: e,
    textColorGhostWarning: c,
    textColorGhostHoverWarning: a,
    textColorGhostPressedWarning: p,
    textColorGhostFocusWarning: a,
    textColorGhostDisabledWarning: c,
    borderWarning: `1px solid ${c}`,
    borderHoverWarning: `1px solid ${a}`,
    borderPressedWarning: `1px solid ${p}`,
    borderFocusWarning: `1px solid ${a}`,
    borderDisabledWarning: `1px solid ${c}`,
    rippleColorWarning: c,
    // error
    colorError: n,
    colorHoverError: C,
    colorPressedError: y,
    colorFocusError: C,
    colorDisabledError: n,
    textColorError: o,
    textColorHoverError: o,
    textColorPressedError: o,
    textColorFocusError: o,
    textColorDisabledError: o,
    textColorTextError: n,
    textColorTextHoverError: C,
    textColorTextPressedError: y,
    textColorTextFocusError: C,
    textColorTextDisabledError: e,
    textColorGhostError: n,
    textColorGhostHoverError: C,
    textColorGhostPressedError: y,
    textColorGhostFocusError: C,
    textColorGhostDisabledError: n,
    borderError: `1px solid ${n}`,
    borderHoverError: `1px solid ${C}`,
    borderPressedError: `1px solid ${y}`,
    borderFocusError: `1px solid ${C}`,
    borderDisabledError: `1px solid ${n}`,
    rippleColorError: n,
    waveOpacity: "0.6",
    fontWeight: O,
    fontWeightStrong: R
  });
}
const j = {
  name: "Button",
  common: z,
  self: L
};
export {
  j as default,
  L as self
};
